<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// No specific rules yet
const rules = { umsokn: {} }
const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lan_nafnabeyting_umsokn_step8_header1') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="umsokn.comment"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step8_athugasemd')"
            variant="outlined"
            rows="4"
            auto-grow
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
